import { track } from '../../services/events';

export function HeroSection({ onStart }: { onStart: () => void }) {
  const start = () => {
    track('start_evaluation_click');
    onStart();
  };
  return (
    <section className="hero container">
      <div>
        <span className="eyebrow">面向 AI 搜索的内容质量评测</span>
        <h1>让每一篇文章，更容易被 AI 看见、理解与引用</h1>
        <p>
          从 AI
          引用潜力、内容结构、品牌实体与人工复核等维度，诊断单篇文章或对比两个版本，并给出可执行的优化建议。
        </p>
        <div className="hero-actions">
          <button className="btn large" onClick={start}>
            开始免费评测
          </button>
          <span>支持单篇评估与双篇对比</span>
        </div>
      </div>
      <div className="hero-visual" aria-label="评分报告预览">
        <div className="mini-report">
          <strong>GEO 内容评测报告</strong>
          <span>综合评分与七项关键指标</span>
        </div>
        <div className="mini-report mini-score">
          <div className="score-badge">86</div>
          <div className="bars">
            <span>AI 引用潜力</span>
            <i style={{ width: '82%' }} />
            <span>内容可抽取性</span>
            <i style={{ width: '74%' }} />
            <span>品牌实体表达</span>
            <i style={{ width: '88%' }} />
          </div>
        </div>
      </div>
    </section>
  );
}
